/**
 * AI 分析 - 投资分析卡片
 */
import React from 'react';
import { Card, Space, Row, Col, Typography, Divider, Alert } from 'antd';
import { DollarOutlined } from '@ant-design/icons';

const { Title } = Typography;

interface EstimatedInvestment {
  initial_inventory: string;
  logistics_fba: string;
  advertising: string;
  total: string;
}

interface ExpectedReturn {
  suggested_price: string;
  monthly_sales_estimate: string;
  monthly_profit: string;
  breakeven_timeline: string;
}

interface InvestmentAnalysis {
  estimated_investment: EstimatedInvestment;
  expected_return: ExpectedReturn;
  roi_analysis: string;
}

interface AIInvestmentAnalysisProps {
  investmentAnalysis: InvestmentAnalysis;
}

export const AIInvestmentAnalysis: React.FC<AIInvestmentAnalysisProps> = ({
  investmentAnalysis,
}) => {
  return (
    <Card
      title={
        <Space>
          <DollarOutlined style={{ color: '#52c41a' }} />
          投资分析
        </Space>
      }
      className="ai-content-card"
    >
      <Row gutter={24}>
        <Col xs={24} md={12}>
          <Title level={5} style={{ color: '#262626', marginBottom: 16 }}>
            💰 预估投入
          </Title>
          <div className="investment-item">
            <span className="investment-item-label">首批库存</span>
            <span className="investment-item-value">
              {investmentAnalysis.estimated_investment.initial_inventory}
            </span>
          </div>
          <div className="investment-item">
            <span className="investment-item-label">物流FBA</span>
            <span className="investment-item-value">
              {investmentAnalysis.estimated_investment.logistics_fba}
            </span>
          </div>
          <div className="investment-item">
            <span className="investment-item-label">广告预算</span>
            <span className="investment-item-value">
              {investmentAnalysis.estimated_investment.advertising}
            </span>
          </div>
          <div className="investment-total">
            <Space direction="vertical" style={{ width: '100%' }}>
              <span className="investment-total-label">总计投入</span>
              <span className="investment-total-value">
                {investmentAnalysis.estimated_investment.total}
              </span>
            </Space>
          </div>
        </Col>
        <Col xs={24} md={12}>
          <Title level={5} style={{ color: '#262626', marginBottom: 16 }}>
            📈 预期回报
          </Title>
          <div className="investment-item">
            <span className="investment-item-label">建议定价</span>
            <span className="investment-item-value">
              {investmentAnalysis.expected_return.suggested_price}
            </span>
          </div>
          <div className="investment-item">
            <span className="investment-item-label">月销预估</span>
            <span className="investment-item-value">
              {investmentAnalysis.expected_return.monthly_sales_estimate}
            </span>
          </div>
          <div className="investment-item">
            <span className="investment-item-label">月利润</span>
            <span className="investment-item-value">
              {investmentAnalysis.expected_return.monthly_profit}
            </span>
          </div>
          <div
            className="investment-total"
            style={{
              background: 'linear-gradient(135deg, #f6ffed 0%, #e6fffb 100%)',
              borderLeft: '4px solid #52c41a',
            }}
          >
            <Space direction="vertical" style={{ width: '100%' }}>
              <span className="investment-total-label">回本周期</span>
              <span className="investment-total-value" style={{ color: '#52c41a' }}>
                {investmentAnalysis.expected_return.breakeven_timeline}
              </span>
            </Space>
          </div>
        </Col>
      </Row>
      <Divider />
      <Alert
        message="ROI 分析"
        description={investmentAnalysis.roi_analysis}
        type="info"
        showIcon
        style={{ borderRadius: 8 }}
      />
    </Card>
  );
};

